// Custom Imports
import axios from "./../../../axios";
import {GET_STUDENT_SIGNUP_DATA, SET_STUDENT_SIGNUP_DATA, GET_TUTOR_SIGNUP_DATA, SET_TUTOR_SIGNUP_DATA} from "./../../action-types";

export const getStudentSignupData = () => {
  return {
    type: GET_STUDENT_SIGNUP_DATA,
  };
};

export const setStudentSignupData = (payload) => {
  return {
    type: SET_STUDENT_SIGNUP_DATA,
    payload,
  };
};

export const getTutorSignupData = () => {
  return {
    type: GET_TUTOR_SIGNUP_DATA,
  };
};

export const setTutorSignupData = (payload) => {
  return {
    type: SET_TUTOR_SIGNUP_DATA,
    payload,
  };
};
